'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '../../../../../shared/cn';
import { Link } from '../../../../actions/Link';
type MobileMenuLinkProps = {
  href: string;
  title: string;
  isHighlighted?: boolean;
  onClick?: () => void;
};
export function MobileMenuLink(t0) {
  const $ = _c(7);
  const {
    href,
    title,
    isHighlighted: t1,
    onClick
  } = t0;
  const isHighlighted = t1 === undefined ? false : t1;
  const t2 = isHighlighted ? "text-algoprimary" : "text-slate-900";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("-mx-3 block rounded-lg px-3 py-2 font-semibold text-base leading-7 hover:bg-slate-50", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== href || $[3] !== onClick || $[4] !== t3 || $[5] !== title) {
    t4 = <Link href={href} className={t3} onClick={onClick}>{title}</Link>;
    $[2] = href;
    $[3] = onClick;
    $[4] = t3;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}